import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentItrackStatusType } from './normalize';

export const fetchShipmentItrackStatusType = createProvider(api.fetchShipmentItrackStatusType)
  .andThen((res) => normalizeShipmentItrackStatusType(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
